/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import settings from './settings';

// Components
import LegalPicker from 'shared/ui/components/form-components/pickers/LegalPicker.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

const __vue_script__ = {
    name: 'LegalOptions',

    components: { LegalPicker, Toggler },

    mixins: [settings],

    data() {
        return {
            organization: {},
            orgName: '',
            legalDocs: [],
            innerValue: {
                show_activation_codes: false,
                show_cookie_banner: false,
                legal_documents: []
            }
        };
    },

    computed: {
        /** @returns {boolean} */
        canChangeActCode() {
            if (this.userIsSuperAdmin || this.userIsAdminOfOrg) {
                // at the org level, if no settings are present, the default value is true, see
                // https://github.com/Spotme/backstage-app/blob/ee1729f15b2809c118f153a3f7bd62274c8643a0/src/ui/components/organizations/WorkspaceDefaultSettingsForm.vue#L75
                const orgShowActivationCode = this.organization.workspace_defaults ? this.organization.workspace_defaults.show_activation_codes : true;
                return orgShowActivationCode || this.event.show_activation_codes;
            }
            return false;
        },

        /** @returns {boolean} */
        canAccessLegalDocs() {
            return this.$services.user.hasPermission(
                'org_realms.read_org_members_legal_docs',
                { org_id: this.event.ownerId, event_id: this.event._id },
            );
        }
    },

    watch: {
        legalDocs(docs) {
            this.innerValue.legal_documents = docs?.map(d => typeof d === 'string' ? d : d._id);
        }
    },

    methods: {
        async init() {
            this.innerValue.show_cookie_banner = this.event.show_cookie_banner;
            this.innerValue.show_activation_codes = this.event.show_activation_codes;
            // Inner value is set in the watch above.
            this.legalDocs = this.event.legal_documents || [];

            await this.loadOrgData();

            this.ready = true;
        },

        async loadOrgData() {
            try {
                if (!this.canAccessOrgData && !this.canAccessLegalDocs) {
                    return;
                }

                this.orgName = this.$services.org.getNameFromId(this.event.ownerId);
                const orgData = await this.$services.org.getOrg(this.orgName);
                this.organization = orgData;
            } catch (error) {
                console.error('[LegalDocuments] Could not load org data', error);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('validation-observer',{ref:"form",staticClass:"legal-options",attrs:{"tag":"form","autocomplete":"off"}},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.legal')))]),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"show_cookie_banner","disabled":!_vm.canChangeSettings,"label":_vm.$t('general_settings.form.cookies_banner'),"off-label":_vm.$t('general.disabled'),"on-label":_vm.$t('general.enabled')},model:{value:(_vm.innerValue.show_cookie_banner),callback:function ($$v) {_vm.$set(_vm.innerValue, "show_cookie_banner", $$v)},expression:"innerValue.show_cookie_banner"}})],1),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"show_activation_codes","disabled":!_vm.canChangeActCode || !_vm.canChangeSettings,"label":_vm.$t('general_settings.form.act_codes'),"off-label":_vm.$t('general.disabled'),"on-label":_vm.$t('general.enabled')},model:{value:(_vm.innerValue.show_activation_codes),callback:function ($$v) {_vm.$set(_vm.innerValue, "show_activation_codes", $$v)},expression:"innerValue.show_activation_codes"}})],1),(_vm.canAccessLegalDocs)?[_c('p',[_vm._v(_vm._s(_vm.$t('general_settings.messages.legal_docs_intro')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"legal_documents"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('legal-picker',{attrs:{"name":"legal_documents","org-name":_vm.orgName,"event-id":_vm.event._id,"disabled":!_vm.canChangeSettings,"label":_vm.$t('general_settings.form.legal_documents'),"emit-initial":false,"placeholder":_vm.$t('general_settings.form.legal_documents_placeholder'),"errors":errors},model:{value:(_vm.legalDocs),callback:function ($$v) {_vm.legalDocs=$$v},expression:"legalDocs"}})]}}],null,false,3301072302)})]:_vm._e()],2)]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LegalOptions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__